import React from 'react';



function FiltersNewWebinar({
                   searchQuery,
                   changeFilterQuery
                 }) {
  return (
    <div className="container_admin_user">
      <div className='col s4 search_admin'>
        <input id="search" type="submit" className="validate" />
        <label htmlFor="search">
          <i className="material-icons icon_search">search</i>
        </label>
        <input
          type="search"
          placeholder="Search"
          value={searchQuery.q}
          onChange={(e) => changeFilterQuery('q', e.target.value)} />
        <i onClick={(e) => changeFilterQuery('q', '')} className="material-icons icon_close">close</i>
      </div>
    </div>
  );
}

FiltersNewWebinar.defaultProps = {};

FiltersNewWebinar.propTypes = {};

export default FiltersNewWebinar;



// WEBPACK FOOTER //
// ./src/components/AddUsersWebinar/FiltersNewWebinar.jsx